
const base64Chars = new Set([
    ...Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/')
])

export function isBase64(str: string) {

    if (!str) {
        return false
    }

    if ((str.length % 4) !== 0) {
        return false
    }

    const paddingCount = str.endsWith('==') ? 2 : str.endsWith('=') ? 1 : 0
    const actualLength = str.length - paddingCount

    for (let i = 0; i < actualLength; i++) {
        if (!base64Chars.has(str[i])) {
            return false
        }
    }

    return true

}
